// extracted by mini-css-extract-plugin
export default {"home":"c-c_cS","home__content":"c-c_cT"};